import { render, staticRenderFns } from "./PopupArView.vue?vue&type=template&id=97fb197e&scoped=true&"
import script from "./PopupArView.vue?vue&type=script&lang=js&"
export * from "./PopupArView.vue?vue&type=script&lang=js&"
import style0 from "./PopupArView.vue?vue&type=style&index=0&id=97fb197e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97fb197e",
  null
  
)

export default component.exports